import { Modal as ModalAtnd, Spin as SpinAntd, Tabs as TabsAntd } from 'antd';
import styled, { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  body, input, button, textarea {
    font-family: Roboto, sans-serif !important;
  }

  /**
  * CLASSES UTILITÁRIAS
  * MARGEM
  * mt-x, mr-x, mb-x, ml-x
  * pt-x, pr-x, pb-x, pl-x
  */
  ${[0, 5, 10, 15, 20, 25, 30, 35, 40, 50].map(
    size => css`
      ${['top', 'right', 'bottom', 'left'].map(
        dir => css`
          .m${dir[0]}-${size}{
            margin-${dir}: ${size}px;
          }
          .p${dir[0]}-${size}{
            padding-${dir}: ${size}px;
          }
        `
      )}
    `
  )}

  .pull-right {
    float: right;
  }

  .pull-left {
    float: left;
  }

  .lh-normal {
    line-height: normal;
  }

  .align-self-center {
    align-self: center;
  }

  /**
  * Ocupar todo tamanho disponível
  */
  .total-width {
    width: 100%;
  }

  /**
  * Posição absoluta
  */
  .position-abs {
    position: absolute !important;
  }

  /**
  * Display block
  */
 .d-block {
    display: block !important;
  }

  /**
  * Design padrão do sistema
  */
  .ant-btn, .ant-input, .ant-input-password {
    border-radius: 6px;
  }

   /**
  * Design padrão do sistema
  */

/**
 * Inputs para o padrão arrendondados
 */
  .ant-select.ant-select-single.ant-select-allow-clear.ant-select-show-search > .ant-select-selector,
  .ant-select.ant-select-single.ant-select-show-search > .ant-select-selector,
  .ant-select.ant-select-single.ant-select-show-arrow > .ant-select-selector {
    border-radius: 6px;
  }

  /**
  * Background de todos os conteúdos
  */
  .ant-layout {
    background-color: #fff;
  }

  .ant-layout.ant-layout-has-sider >.ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
    overflow-x: hidden;
  }

  /**
  * Background do menu
  */
  .ant-layout-sider {
    background: #090E38;
  }

  /**
  * Background dos itens de menu
  */


  .ant-menu-dark, .ant-menu-dark .ant-menu-sub {
    background: #090E38 !important;
  }

  .ant-layout-sider-trigger {
    background: rgba(255, 255, 255, 0.1);
  }

  /**
  * Background do menu header
  */
  .ant-layout-header {
    background: #fff;
    height: 50px;
    padding: 0;
    line-height: 55px;
    position: sticky;
    top: 0;
    z-index: 99;
    border-bottom: 1px solid #CDCDCD;
  }

  /**
  * Texto do divider
  */
  .ant-divider-inner-text {
    color: rgba(0, 0, 0, 0.65);
    font-weight: 600;
    font-size: 16px;
  }

  .popover-tmov {
    font-family: sans-serif;
    .ant-popover-inner {
      border-radius: 8px;
      background-color: #0D3549;
    }

    .ant-popover-inner-content {
      color: white;
    }

    .ant-popover-title {
      color: white;
      font-weight: bold;
      font-size: 18px;
    }

    .ant-popover-arrow {
      top: 8px !important;
      border-top-color: #0D3549 !important;
      border-left-color: #0D3549 !important;
    }
  }

  .capitalize {
    text-transform: capitalize;
  }

  .opacity01 {
    opacity: 0.1;
  }

  .ant-form-item-tooltip {
    color: black!important;
  }
`;

export const Tabs = styled(TabsAntd)`
  .ant-tabs-ink-bar {
    background: #24a95d !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #24a95d !important;
  }

  .ant-tabs-tab:hover {
    color: #24a95d !important;
  }

  .center-loading-spin {
    text-align: center;
  }
`;

export const Modal = styled(ModalAtnd)`
  .ant-modal-header {
    border-bottom: 1px solid #bdbdbd;
  }

  .ant-modal-title {
    color: #4f4f4f;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
  }
`;

export const Message = styled.p`
  margin: ${props => props.margin || '5px 0 0'};
  font-size: 11px;
  font-weight: normal;
`;

export const TextColor = styled.span`
  color: ${props => props.color || '#000'};
`;

export const Spin = styled(SpinAntd)`
  max-height: 100% !important;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;
